/* eslint-disable react/jsx-indent, react/jsx-closing-tag-location */
import React from 'react'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Box, ToggleButton, ToggleButtonGroup, Typography, alpha } from '@mui/material'

import { BREAKDOWN_BY } from './chargesPanelUtils'

ChartJS.register(ArcElement, Tooltip, Legend)

const breakdownTitle = (mode) => {
  if (mode === BREAKDOWN_BY.CHARGE_TYPE) return 'Billing share by charge type'
  if (mode === BREAKDOWN_BY.CLIENT) return 'Billing share by client'
  return 'Billing share by month'
}

const BillingChargesBreakdownPie = ({
  bill,
  accent,
  breakdownMode,
  onBreakdownModeChange,
  chartData,
  chartOptions,
  labelPlugins
}) => {
  const title = breakdownTitle(breakdownMode)

  return (
    <Box
      sx={{
        flex: { md: '0 0 300px' },
        width: { xs: '100%', md: 300 },
        minWidth: { md: 280 },
        maxWidth: { md: 340 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        px: { xs: 1.25, sm: 1.75 },
        py: { xs: 1.5, md: 1.5 },
        gap: 1.25,
        backgroundColor: alpha(bill.surface, 0.12)
      }}
    >
      <ToggleButtonGroup
        exclusive
        size='small'
        value={breakdownMode}
        onChange={(e, v) => v && onBreakdownModeChange(v)}
        sx={{
          alignSelf: 'stretch',
          flexWrap: 'wrap',
          gap: 0.5,
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '0.75rem',
            px: 1,
            py: 0.45,
            color: bill.muted,
            borderColor: alpha(accent, 0.35),
            '&.Mui-selected': {
              color: bill.text,
              backgroundColor: alpha(accent, 0.22),
              borderColor: alpha(accent, 0.55),
              '&:hover': { backgroundColor: alpha(accent, 0.3) }
            }
          }
        }}
      >
        <ToggleButton value={BREAKDOWN_BY.CHARGE_TYPE}>Charge type</ToggleButton>
        <ToggleButton value={BREAKDOWN_BY.CLIENT}>Client</ToggleButton>
        <ToggleButton value={BREAKDOWN_BY.MONTH}>Month</ToggleButton>
      </ToggleButtonGroup>

      {chartData
        ? (
          <Box sx={{ width: '100%', flex: 1, minHeight: 240, display: 'flex', flexDirection: 'column' }}>
            <Typography variant='subtitle2' sx={{ fontWeight: 700, mb: 0.5, textAlign: 'center', color: bill.text }}>
              {title}
            </Typography>
            <Box sx={{ flex: 1, minHeight: 200, maxHeight: 280, position: 'relative' }}>
              <Pie data={chartData} options={chartOptions} plugins={labelPlugins} />
            </Box>
          </Box>
          )
        : (
          <Box
            sx={{
              flex: 1,
              minHeight: 120,
              py: 2,
              px: 1.5,
              textAlign: 'center',
              borderRadius: 2,
              border: `1px dashed ${alpha(bill.border, 0.9)}`,
              backgroundColor: alpha(bill.surface, 0.25),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography variant='body2' sx={{ color: bill.muted, fontSize: '0.8rem' }}>
              Nothing to chart for the current graph selection. Turn charge types or rows on, or clear the search box.
            </Typography>
          </Box>
          )}
    </Box>
  )
}

export { BillingChargesBreakdownPie }
